import React, { FC, useEffect, useState } from "react";
import {
  BanFromOrgButtonProps,
  ChatUser,
  Provider,
} from "@zeemee/react-web-chat";
import { Status, statusVar } from "@/reactiveVars/chat";
import { PageLoader } from "../PageLoader";
import { useProviderConfig } from "./useProviderConfig";
import { ReactWebChatMiniChat } from "./ReactWebChatMiniChat";
import { BanFromOrg } from "@/components/BanFromOrg";
import { useOrg } from "@/hooks/useOrg";
import { PageError } from "../PageError";
import { UserDisplayWrapper, FullPageChatLink } from "./components";

interface ReactWebChatProviderProps {
  children: React.ReactNode;
}

export const ReactWebChatProvider: FC<ReactWebChatProviderProps> = ({
  children,
}) => {
  const { status, config } = useProviderConfig();

  useEffect(() => {
    statusVar(status);
  }, [status]);

  const { org } = useOrg();
  const [banUser, setBanUser] = useState<ChatUser | null>(null);

  if (status === Status.BOOTSTRAP_IN_PROGRESS) {
    return <PageLoader />;
  }

  if (status === Status.BOOTSTRAP_ERROR) {
    return <PageError />;
  }

  const BanFromOrgButton: FC<BanFromOrgButtonProps> = ({
    user,
    onClick,
    children,
    ...props
  }) => (
    <button
      {...props}
      onClick={(e) => {
        setBanUser(user);
        onClick?.(e);
      }}
    >
      {children}
    </button>
  );

  // typescript not smart enough to know this is the only possible state left,
  // so we have to 'check' to make it happy.
  if (status === Status.BOOTSTRAP_SUCCESS) {
    return (
      <Provider
        {...config}
        components={{
          banFromOrgButton: BanFromOrgButton,
          fullPageChatLink: FullPageChatLink,
          userDisplayWrapper: UserDisplayWrapper,
        }}
      >
        {children}

        <ReactWebChatMiniChat />

        {/* Ban from organization dialog */}
        {banUser && org && (
          <BanFromOrg
            open={true}
            onOpenChange={() => setBanUser(null)}
            orgId={org.id}
            userId={banUser.id}
          />
        )}
      </Provider>
    );
  }
};
